import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import NetwalaSelect from "../Items/Select/Index";
import "./styles/RequestIPTVModal.css";

interface BulkUpdateAreaModalProp {
  show: boolean;
  handleClose: (reload?: boolean) => void;
  connectionIds: number[];
}

const BulkUpdateAreaModal: React.FC<BulkUpdateAreaModalProp> = ({
  show,
  handleClose,
  connectionIds,
}) => {
  const [form] = Form.useForm();

  const { openNotification, contextHolder } = useMultiNotification();
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSubArea, setSelectedSubArea] = useState<null | string>(null);
  const [areas, setAreas] = useState<NetwalaSelectOptions[]>([]);
  const [subAreas, setSubAreas] = useState<NetwalaSelectOptions[]>([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<any>("connections/bulkUpdateArea", true);

  const [
    getAreasApi,
    areasApiResponse,
    areasApiError,
    areasApiLoading,
    areasApiMessage,
    areasApiErrorCount,
  ] = useAxiosPost<ResponseProp>("areas/getAreasByOwner");
  const [
    getSubAreasApi,
    subAreasApiResponse,
    subAreasApiError,
    subAreasApiLoading,
    subAreasApiMessage,
    subAreasApiErrorCount,
  ] = useAxiosPost<SubAreasByAreaIDApiProp>("areas/getSubAreasByAreaID");

  useEffect(() => {
    if (show) {
      getAreasApi({});
      form.resetFields();
      setSelectedArea("");
      setSelectedSubArea(null);
      setSubAreas([]); // Clear sub areas array when modal opens
    }
  }, [show]);

  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      const areas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setAreas(areas);
    }
  }, [areasApiResponse]);
  useEffect(() => {
    if (subAreasApiResponse !== null) {
      const data: any = subAreasApiResponse.responseData;
      const subAreas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setSubAreas(subAreas);
    }
  }, [subAreasApiResponse]);

  const onFinish = (values: any) => {
    const { area, subArea } = values;
    const dataToSend = {
      connectionIds: connectionIds,
      areaId: subArea !== undefined && subArea !== null ? subArea : area,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  const onFinishFailed = (errorInfo: any) => {};

  const handleAreaChange = (value: string) => {
    setSelectedArea(value);
    setSelectedSubArea(null);
    setSubAreas([]); // Clear sub areas array when area changes
    form.setFieldsValue({ subArea: undefined });
    getSubAreasApi({ intPkAreaID: Number(value) });
  };

  return (
    <>
      <NetwalaModal
        title="Bulk Update Area"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        {contextHolder}
        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
              name="bulkUpdateAreaForm"
            >
              <Form.Item
                label={<span className="create-user-form-label">Area</span>}
                name="area"
                rules={[{ required: true, message: "Please select an area!" }]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedArea}
                  onChange={handleAreaChange}
                  size="large"
                  height="45px"
                  options={areas}
                />
              </Form.Item>

              {subAreas.length > 0 && (
                <Form.Item
                  label={
                    <span className="create-user-form-label">Sub Area</span>
                  }
                  name="subArea"
                >
                  <NetwalaSelect
                    showSearch
                    value={selectedSubArea}
                    size="large"
                    height="45px"
                    options={subAreas}
                    onChange={(value) => {
                      setSelectedSubArea(value);
                      form.setFieldsValue({ subArea: value || undefined });
                    }}
                  />
                </Form.Item>
              )}

              <Form.Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <NetwalaButton
                    backgroundColor={ButtonProps.background.SECONDARY}
                    height={ButtonProps.height.STANDARD}
                    width="120px"
                    textColor={ButtonProps.color.BLACK}
                    onClick={() => handleClose(false)}
                    text="Cancel"
                    disabled={apiLoading}
                  />
                  <NetwalaButton
                    backgroundColor={ButtonProps.background.YELLOW}
                    height={ButtonProps.height.STANDARD}
                    width="120px"
                    textColor={ButtonProps.color.STANDARD}
                    onClick={() => {}}
                    htmlType="submit"
                    text="Update Area"
                    borderColor="#FFA726"
                    disabled={apiLoading}
                  />
                </div>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default BulkUpdateAreaModal;
